(() => {
  const initSection = (root) => {
    const bar = root.querySelector('.js-comparison-table-v2__progress');
    const scroller = root.querySelector('.js-comparison-table-v2__scroller');

    if (!bar || !scroller) return;

    const update = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;

      bar.value =
        maxScroll <= 0
          ? 100
          : Math.min(100, Math.max(0, (scroller.scrollLeft / maxScroll) * 100));
    };

    update();
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };

  // Scoped per section: a page can hold more than one comparison table.
  const initAll = () => {
    document.querySelectorAll('.comparison-table-v2').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor swaps section markup without reloading the page.
  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
